<template>
  <!-- 2カラムページの場合は'is-2column'クラスを付与 -->
  <!-- ヘッダーを隠すの場合は'is-hidden-header'クラスを付与 -->
  <div id="body" class="is-2column" 
    :class="[
      {'is-hidden-header' : targetScrollFlg},
      {'is-visible-login': documentLogic.state.isFrontendLogin}
    ]"
  >
  <BackgroundImage />
  <div class="login-bar" v-if="documentLogic.state.isFrontendLogin">
    <span>フロントエンドログイン中</span>
  </div>

  <PCPrint :pageTitle="documentLogic.data.detail.title" />
    <div id="wrapper">
      <PCDocumentMenu
        :bookName="documentLogic.state.bookName"
        :booksArray="documentLogic.state.books"
        :currentIndex="documentLogic.state.tab" 
        :showBookmark="documentLogic.state.isShowDetail"
        :isBookmark="documentLogic.data.detail.bookmarks_id !==0"
        :isFrontendLogin="documentLogic.state.isFrontendLogin"
        class="document-header"
        @clickBookmark="documentLogic.clickBookmark"
        @changeBook="documentLogic.selectBook"
      />

      <!-- 並び順モーダル -->
      <transition name="popup">
        <PCDocumentOrderSetting
          v-if="documentLogic.state.visibleSearchOrderSettings"
          :isKeywordsEmpty="!formData.sendFormParams.search_text"
          @close="documentLogic.state.visibleSearchOrderSettings = false"
          @submit="logic.submitSettings"
        />
      </transition>

      <!-- 表示設定モーダル -->
      <transition name="popup">
        <PCDocumentDisplaySetting
          v-if="documentLogic.state.visibleSearchDisplaySettings"
          @close="documentLogic.state.visibleSearchDisplaySettings = false"
          @submit="logic.submitSettings"
        />
      </transition>

      <!-- 裁判所検索モーダル -->
      <transition name="popup">
        <PCDocumentCourtList
          v-if="documentLogic.state.visibleSaibansyoSettings"
          :startLoading="documentLogic.state.visibleSaibansyoSettings && !documentLogic.state.isMasterLoading"
          :saibansyoList="documentLogic.data.saibansyo" 
          @updateCourtName="logic.updatSaibansyoName"
          @closeSearchDetailCourtList="documentLogic.state.visibleSaibansyoSettings = false"
        />
      </transition>

      <!-- ノートの選択（新規ノートを作成して保存する ＆ 保存先のノートを選ぶ） -->
      <transition name="popup">
        <PCNoteSelect
          v-if="documentLogic.state.visibleNoteSelect"
          :type="'pj'"
          :pageId="documentLogic.state.detailId"
          :title="documentLogic.state.detailName"
          @closeSelectNote="documentLogic.state.visibleNoteSelect = false"
        />
      </transition>

      <!-- content:start -->
      <div class="document-wrap" id="content">
        <div class="box02 white">
          <div class="document-column col-2">
            <div class="document-column-item form"
              :class="{ 'is-small': documentLogic.state.isShowDetail && documentLogic.state.isSmallForm }"
              @click="documentLogic.showDetail.showForm"
            >
              <form class="document-search" onsubmit="return false;" ref="form">
                <p class="document-search-title">{{documentLogic.state.subTitle}}</p>
                <div class="document-search-body">
                  <div class="document-formbox small">
                    <p class="document-formbox-title">検索分類選択</p>
                    <SelectBoxPC
                      :lists="formData.types"
                      :selected="formData.selectedType"
                      @change="oparationSelectbox.changeType" />
                  </div>

                  <!-- 検索キーワード -->
                  <div class="document-formbox">
                    <p class="document-formbox-title">検索キーワード（AND検索）</p>
                    <p class="error-message" v-if="formError.keyword">{{ formError.keyword }}</p>
                    <div class="formparts text">
                      <input type="text" name="document-keyword" placeholder="キーワードを入力（最大50文字）" v-model="formData.keyword">
                    </div>
                    <div class="document-search-formparts" :class="{ 'right': formData.selectedType === 0 }">
                      <div class="document-search-formparts-item" v-if="formData.selectedType !== 0">
                        <div class="formparts radio">
                          <input type="radio" id="radio1" v-model="formData.keywordType" value="1">
                          <label for="radio1">要旨・内容</label>
                        </div>
                        <div class="formparts radio">
                          <input type="radio" id="radio2" v-model="formData.keywordType" value="2">
                          <label for="radio2">テーマ</label>
                        </div>
                      </div>
                      <div class="document-search-formparts-item">
                        <div class="formparts checkbox">
                          <input type="checkbox" id="checkbox2" v-model="formData.keywordOption">
                          <label for="checkbox2">
                            <span>表記ゆれ・同意語を含む</span>
                            <FontawesomeIcon icon="check" class="icn" />
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- 日付 -->
                  <div class="document-formbox pt20" v-if="formData.selectedType !== 0">
                    <div class="document-formbox calendar">
                      <p class="document-formbox-title" v-if="formData.selectedType === 1">年月日</p>
                      <p class="document-formbox-title" v-if="formData.selectedType === 2">裁判年月日</p>
                      <div class="formparts">
                        <div class="document-formbox-content">
                          <div class="inline-wrap">
                            <SelectBoxPC
                            :lists="formData.date1.era"
                            :selected="formData.date1.selectedEra"
                            @change="oparationSelectbox.changeEra1" />
                            <SelectBoxPC
                              :lists="formData.date1.year"
                              :selected="formData.date1.selectedYear"
                              @change="oparationSelectbox.changeYear1" />
                            <p class="inline-text">年</p>
                            <SelectBoxPC
                              :lists="formData.date1.month"
                              :selected="formData.date1.selectedMonth"
                              @change="oparationSelectbox.changeMonth1" />
                            <p class="inline-text">月</p>
                            <SelectBoxPC
                              :lists="formData.date1.day"
                              :selected="formData.date1.selectedDay"
                              @change="oparationSelectbox.changeDay1" />
                            <p class="inline-text" v-if="formData.selectedRestriction === 1">日から</p>
                            <p class="inline-text" v-else>日</p>
                            <SelectBoxPC
                              :lists="formData.restrictionList"
                              :selected="formData.selectedRestriction"
                              @change="oparationSelectbox.changeRestriction" />
                          </div>
                        </div>
                        <p class="error-message" v-if="formError.date1">{{ formError.date1 }}</p>
                        <div class="document-formbox-content">
                          <div class="inline-wrap" v-if="formData.selectedRestriction === 1">
                            <SelectBoxPC
                            :lists="formData.date2.era"
                            :selected="formData.date2.selectedEra"
                            @change="oparationSelectbox.changeEra2" />
                            <SelectBoxPC
                              :lists="formData.date2.year"
                              :selected="formData.date2.selectedYear"
                              @change="oparationSelectbox.changeYear2" />
                            <p class="inline-text">年</p>
                            <SelectBoxPC
                              :lists="formData.date2.month"
                              :selected="formData.date2.selectedMonth"
                              @change="oparationSelectbox.changeMonth2" />
                            <p class="inline-text">月</p>
                            <SelectBoxPC
                              :lists="formData.date2.day"
                              :selected="formData.date2.selectedDay"
                              @change="oparationSelectbox.changeDay2" />
                            <p class="inline-text">日まで</p>
                          </div>
                        </div>
                        <p class="error-message" v-if="formError.date2">{{ formError.date2 }}</p>
                      </div>
                    </div>
                  </div>

                  <!-- 先例：発翰番号 -->
                  <div class="document-formbox" v-if="formData.selectedType === 1">
                    <div class="document-formbox num">
                      <p class="document-formbox-title">発翰番号</p>
                      <p class="error-message" v-if="formError.hakkan">{{ formError.hakkan }}</p>
                      <div class="document-formbox-content wrap">
                        <SelectBoxSP
                          class="full"
                          :lists="formData.hakkan"
                          :selected="formData.selectedHakkan"
                          @change="oparationSelectbox.changeHakkan" />
                        <span>第</span>
                        <div class="formparts text long">
                          <input type="text" name="document-hakkan1" placeholder="2" v-model="formData.hakkanNum1">
                        </div>
                        <span>号</span>
                        <div class="formparts text short">
                          <input type="text" name="document-hakkan2" placeholder="2" v-model="formData.hakkanNum2">
                        </div>
                        <span>・</span>
                        <div class="formparts text short">
                          <input type="text" name="document-hakkan3" placeholder="2" v-model="formData.hakkanNum3">
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- 判例：裁判所・事件番号・出典 -->
                  <div class="document-formbox" v-if="formData.selectedType === 2">
                    <p class="document-formbox-title">裁判所</p>
                    <p class="txt mb8">検索対象となる裁判所を選択してください。<span v-if="formData.saibansyoName !== ''" @click="logic.clearSaibansyoName" class="txt-blue ml20" role="button">指定をクリア</span></p>
                    <div class="column">
                      <div class="column-item col-9">
                        <div class="formparts text is-inactive">
                          <input v-model="formData.saibansyoName" type="text" readonly>
                        </div>
                      </div>
                      <div class="column-item col-3 space-left">
                        <div class="button">
                          <span class="btn" role="button"
                            @click="documentLogic.state.visibleSaibansyoSettings = true"
                          >
                            裁判所検索
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="document-formbox num">
                      <p class="document-formbox-title">事件番号</p>
                      <p class="error-message" v-if="formError.jiken">{{ formError.jiken }}</p>
                      <div class="document-formbox-content">
                        <SelectBoxPC                       
                          :lists="formData.jiken"
                          :selected="formData.selectedJiken"
                          @change="oparationSelectbox.changeJiken"
                          class="upper" />
                        <span></span>
                        <div class="formparts text long">
                          <input type="text" name="document-jiken1" placeholder="2" v-model="formData.jikenNum1">
                        </div>
                        <span>年（</span>
                        <div class="formparts text short">
                          <input type="text" name="document-jiken2" placeholder="イ" v-model="formData.jikenNum2">
                        </div>
                        <span>）第</span>
                        <div class="formparts text long">
                          <input type="text" name="document-jiken3" placeholder="1234" v-model="formData.jikenNum3">
                        </div>
                        <span>号</span>
                      </div>
                    </div>
                    <div class="document-formbox num">
                      <p class="document-formbox-title">出典</p>
                      <p class="error-message" v-if="formError.syuttenn">{{ formError.syuttenn }}</p>
                      <div class="document-formbox-content">
                        <SelectBoxPC
                          class="long"
                          :lists="formData.syuttenn"
                          :selected="formData.selectedSyuttenn"
                          @change="oparationSelectbox.changeSyuttenn" />
                        <span></span>
                        <div class="formparts text max">
                          <input type="text" name="document-syuttenn" placeholder="12巻3号456頁は　12・3・456　と入力" v-model="formData.syuttennText">
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- submitボタン -->
                  <div class="document-formbox submit">
                    <div class="button">
                      <button type="submit" name="button" class="btn ga-search-precedent" @click="logic.submitForm">この条件で検索</button>
                    </div>
                    <button class="document-formbox-clear" @click="resetForm.reset">検索条件をクリア</button>
                  </div>
                </div>
              </form>
            </div>
            <div 
              class="document-column-item searchResult" 
              :class="{ 'is-small': (documentLogic.state.isShowDetail && !documentLogic.state.isSmallForm) }"
              @click="documentLogic.showDetail.showResult"
            >
              <PCDocumentPartSummary
                :bookName="documentLogic.state.bookName"
                :url="documentLogic.data.summaryUrl"
                v-show="!documentLogic.state.isShowResult"
              />
              <div class="document-result" v-show="documentLogic.state.isShowResult">
                <div class="document-result-column" v-if="!documentLogic.state.isFilteredTheme">
                  <p class="document-result-title"><strong>検索結果</strong><small>{{pagenation.totalItems}}件</small></p>
                  <div class="document-result-buttons">
                    <button @click="documentLogic.state.visibleSearchOrderSettings = true">並び替え設定</button>
                    <button @click="logic.saveSearch">検索条件の保存</button>
                    <button @click="documentLogic.state.visibleSearchDisplaySettings = true">表示件数</button>
                  </div>
                </div>
                <p class="document-result-title" v-if="documentLogic.state.isFilteredTheme" v-html="documentLogic.state.themeName"></p>
                <div class="document-result-body" ref="resultList">
                  <p v-if="(!documentLogic.state.isListLoading && !documentLogic.state.isMasterLoading) && (!documentLogic.data.list || documentLogic.data.list.length === 0)" class="txt pt32 pb32 pl40 pr40">検索条件に合致する検索結果がありませんでした。<br>検索条件を変更して再度検索してください。</p>
                  <PCDocumentPagenation
                    v-if="!documentLogic.state.isListLoading && pagenation.isPaginationShown && !documentLogic.state.isFilteredTheme"
                    :count="pagenation.totalItems"
                    :per_page="settings.perPage"
                    :currentPage="pagenation.currentPage"
                    @changePage="pagenation.onPageChanged"
                  />
                  <div class="document-result-pages ">
                    <FontawesomeIcon v-if="documentLogic.state.isListLoading || documentLogic.state.isMasterLoading" :icon="['fal','spinner-third']" size="2x" class="icn fa-spin" style="height:100%;" />
                    <template v-else>
                      <PCDocumentPartResultItem
                        v-for="(item, i) in documentLogic.data.list"
                        :key="item.id"
                        :item="item"
                        :isFilteredTheme="documentLogic.state.isFilteredTheme"
                        @clickFilterTheme="documentLogic.clickFilterTheme"
                        @clickViewLater="documentLogic.clickViewLater"
                        @detailClick="documentLogic.showDetail.open"
                        @openRelated="documentLogic.showDetail.openRelated(i)"
                        @openReference="documentLogic.showDetail.openReference(i)"
                      />
                    </template>
                  </div>
                  <PCDocumentPagenation
                    v-if="!documentLogic.state.isListLoading && pagenation.isPaginationShown && !documentLogic.state.isFilteredTheme"
                    :count="pagenation.totalItems"
                    :per_page="settings.perPage"
                    :currentPage="pagenation.currentPage"
                    @changePage="pagenation.onPageChanged"
                  />
                </div>
              </div>
            </div>
            <div class="document-column-item" v-if="documentLogic.state.isShowDetail">
              <PCDocumentPartDetail
                :item="documentLogic.data.detail"
                :isLoading="documentLogic.state.isDetailLoading || documentLogic.state.isMasterLoading"
                @clickNote="documentLogic.state.visibleNoteSelect = true"
              />
            </div>
          </div>
        </div>
      </div>
      <!-- content:end -->
    </div>
  </div>
</template>

<script>
import { defineComponent, onMounted } from '@vue/composition-api'

import PCPrint from '@/components/pc/partial/PCPrint.vue'
import PCDocumentMenu from '@/components/pc/partial/PCDocumentMenu'
import PCMenu from '@/components/pc/popup/PCMenu.vue'
import PCDocumentPartSummary from '@/components/pc/partial/document/PCDocumentPartSummary.vue'
import PCDocumentPartDetail from '@/components/pc/partial/document/PCDocumentPartDetail.vue'
import PCDocumentPartResultItem from '@/components/pc/partial/document/PCDocumentPartResultItem.vue'
import PCDocumentOrderSetting from '@/components/pc/popup/PCDocumentOrderSetting.vue'
import PCDocumentDisplaySetting from '@/components/pc/popup/PCDocumentDisplaySetting.vue'
import PCDocumentCourtList from '@/components/pc/popup/PCDocumentCourtList.vue'
import PCBasicToast from '@/components/pc/popup/PCBasicToast.vue'
import PCDocumentPagenation from '@/components/pc/partial/PCDocumentPagenation.vue'
import SelectBoxPC from '@/components/pc/partial/SelectBox.vue'
import SelectBoxSP from '@/components/sp/partial/SelectBox.vue'
import PCNoteSelect from '@/components/pc/popup/PCNoteSelect.vue'

import { DocumentSearch } from '@/logic/document/DocumentSearch'

export default defineComponent({
  props: {
    // 先例・判例詳細ID：URLで渡された値(/routes/index.jsで定義)
    detailId: {
      type: Number,
      default: 0
    }
  },
  components: {
    PCPrint,
    PCDocumentMenu,
    PCMenu,
    PCDocumentPartSummary,
    PCDocumentPartDetail,
    PCDocumentPartResultItem,
    SelectBoxPC,
    PCDocumentOrderSetting,
    PCBasicToast,
    PCDocumentDisplaySetting,
    PCDocumentCourtList,
    PCDocumentPagenation,
    PCNoteSelect,
    SelectBoxSP
  },  
  setup (props, context) {
    return {
      ...DocumentSearch(props, context)
    }
  }
})
</script>

<style lang="scss" scoped>
.formparts.select.upper {
  // z-index: 11;
  &-large {
    z-index: 22;
  }
}

.half {
  width: 50%;
}

.inline-wrap {
  display: inline-flex;
  flex-wrap: wrap;
  .formparts + .formparts {
    margin-top: 0;
    margin-left: 8px;
  }
  .inline-text {
    display: inline-flex;
    align-items: center;
    margin: 0 8px;
  }
}

.is-visible-login {
  .popup-wrapper {
    top: 50px;
  }
  #wrapper {
    padding-top: 136px;
  }
  #bg-image {
    top: 50px;
  }
}

.login-bar {
  position: fixed;
  top: 0;
  height: 50px;
  box-sizing: border-box;
  z-index: 10;
  width: 100%;
  background-color: $color-hdg;
  color: #fff;
  font-size: 1.8rem;
  padding: 12px 52px 12px 12px;
}
</style>
